import { Component, OnInit, Inject } from '@angular/core';

import { DatePipe } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-password-dialog',
  templateUrl: './confirm-password-dialog.component.html',
  styleUrls: ['./confirm-password-dialog.component.scss']
})
export class ConfirmPasswordDialogComponent implements OnInit {
  submitted = false;
  password: any;
  myDate:any;
  constructor(
    public dialogRef: MatDialogRef<ConfirmPasswordDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,   
    ) {      
     }

  ngOnInit() {
  }

  done() {
    this.submitted = true;
    if (this.password) {
      this.dialogRef.close(this.password);
    }
  }
  closeModal() {
    this.dialogRef.close();
  }
}
